import Component from './left-panel-layout.vue'
export default Component
